module.exports = __webpack_public_path__ + "static/media/home-car.4d83868f.svg";